// extracted by mini-css-extract-plugin
export default {"reactDropdownContainer":"SurveySelectBiobank_reactDropdownContainer__mnvTJ"};